/**
 * --------------------------------------------------------------------------
 * Basic Modules: ObjectFit.js
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'objectFit';
const LOG_KEY           = `[${NAME}]`;

class ObjectFit {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        objectFitImages();
        objectFitVideos();
    }

    destroy() {}

    // Private

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        new ObjectFit();
    }
}

export default ObjectFit;
